<template>
	<div class="w-100">
		<b-skeleton-wrapper :loading="display.loading" class="pb-5 mb-5 border-b-semi-grey">
			<template #loading>
				<b-row class="slim-grid-row">
					<b-col cols="12" class="mb-3">
						<b-skeleton width="20%" height="40px"></b-skeleton>
						<b-skeleton width="50%" height="20px"></b-skeleton>
					</b-col>
					<b-col cols="6" v-for="i in 2" :key="i">
						<b-card body-class="p-0">
							<b-skeleton-img no-aspect width="100%" height="160px" card-img="top"></b-skeleton-img>
							<b-card-body>
								<b-skeleton width="80%" height="30px"></b-skeleton>  
								<b-skeleton width="30%" height="25px"></b-skeleton>
								<b-row class="slim-grid-row mb-3">
									<b-col cols="3">
										<b-skeleton width="100%" height="20px"></b-skeleton>
									</b-col>
									<b-col cols="3">
										<b-skeleton width="100%" height="20px"></b-skeleton>
									</b-col>
									<b-col cols="3">
										<b-skeleton width="100%" height="20px"></b-skeleton>
									</b-col>
								</b-row>
								<b-row class="slim-grid-row">
									<b-col cols="6">
										<b-skeleton width="100%" height="37px"></b-skeleton>
									</b-col>
									<b-col cols="6">
										<b-skeleton width="100%" height="37px"></b-skeleton>
									</b-col>
								</b-row>
							</b-card-body>
						</b-card>
					</b-col>
				</b-row>
			</template>

			<div class="w-100 pb-4 mb-5 border-b-semi-grey"  v-if="display.data.length > 0">
				<template v-if="display.data.length > 0">
					<div class="row slim-grid-row">
						<div class="col-8">
							<p class="heading-5 mb-1">{{$t('hotel.room-type.room-type')}}</p>
							<p class="body-2-2-1 sub-title text-15 mb-4">{{$t('hotel.room-type.home-sub')}}</p>
						</div>
						<div class="col-4 text-right align-self-center" v-if="display.data.length > 2">
							<router-link :to="'/'+getMerchant.code+'/room-type'">
								<p class="mb-0 body-3-1 text-14 cursor-pointer d-inline-block mt-4 text-green border-bottom-green">{{$t('hotel.room-type.show-all')}}</p>
							</router-link>
						</div>
					</div>
					<div class="w-100" v-if="display.data.length < 2">
						<div class="px-4 pt-4 pb-1 border radius-6 w-100 mb-3" :id="data.id" v-for="(data, index) in display.data">
							<div class="w-100">
								<div class="img-hover-zoom radius-6">
									<flickity ref="flickity" class="" :options="freeScrollSliderGallery" v-if="data.image.length != 0 ">
										<div class="carousel-cell w-100" v-for="image in data.image">
											<div class="img-hover-zoom radius-6 blur-image-bg" style="height:270px;">
												<img :src="image.image_url" class="slider-hover img" :alt="getMerchant.name">
                        <div class="bg" :style="{ backgroundImage: `url('${image.image_url}')` }"></div>
											</div>
										</div>
									</flickity>
									<img :src="image_undefine" v-else class="img-fit slider-hover" :alt="getMerchant.name" style="height:275px;">
								</div>
								<div class="w-100 pt-3">
									<router-link :to="'/'+getMerchant.code+'/room-type/'+data.id+''">
										<p class="mb-1 body-1-2 font-bold text-18">{{data.name}}</p>
									</router-link>
									<p class="mb-0 body-2-2 text-14">{{$t('hotel.starting-from')}}:</p>
									<p class="mb-2 body-2-2-3 text-16 text-orange">{{formatCurrency(data.best_price.final_price)}}</p>
									<div class="pb-2">
										<div class="d-inline-block mr-2 mb-1" id="room-size">
											<i class="simple-icon-size-fullscreen text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
											<p class="mb-0 body-2-1 d-inline-block align-middle">{{data.room_size}} m²</p>
										</div>
										<b-tooltip target="room-size" placement="bottom" :title="$t('hotel.unit-type.'+data.type+'.size')">
										</b-tooltip>
										<div class="d-inline-block mr-2 mb-1" id="total-room">
											<i class="simple-icon-home text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
											<p class="mb-0 body-2-1 d-inline-block align-middle">{{data.total_rooms}} {{$t('hotel.room-type.rooms')}}</p>
										</div>
										<b-tooltip target="total-room" placement="bottom" :title="$t('hotel.room-type.total-unit')">
										</b-tooltip>
										<div class="d-inline-block mr-2" id="bed">
											<i class="simple-icon-grid text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
											<p class="mb-0 body-2-1 d-inline-block align-middle text-truncate">
												<template v-for="(bed, index) in data.bed">
													{{bed.qty}} {{bed.name}}<span v-if="index + 1 < data.bed.length">,</span>
												</template>
											</p>
										</div>
										<b-tooltip target="bed" placement="bottom" :title="$t('hotel.room-type.bed-type')">
										</b-tooltip>
									</div>
									<p class="mb-0 body-2-2-1 mb-0 text-15 text-truncate-2">{{data.desc}}</p>
									<div class="row slim-grid-row mt-3">
										<div class="d-inline-block mr-3 mb-3">
											<router-link :to="'/'+getMerchant.code+'/room-type/'+data.id+''">
												<button type="button" class="px-5 ga-btn-primary-md ga-btn-primary-outline">{{$t('hotel.concierge.fitur.read-more')}}</button>
											</router-link>
										</div>
										<div class="d-inline-block">
											<router-link :to="'/'+getMerchant.code+'/hotel-direct-detail/room_type/room_type/'+data.id+''">
												<button type="button" class="px-5 ga-btn-primary-md ga-btn-primary">{{$t('hotel.action.book-now')}}</button>
											</router-link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-else>
						<flickity ref="flickity" class="mb-3" :options="freeScrollSlider">
							<div class="carousel-cell p-3 border w-50 mb-3 mr-3" :id="data.id" v-for="(data, index) in display.data">
								<div class="w-100">
									<div class="img-hover-zoom radius-6">
										<flickity ref="flickity" class="" :options="freeScrollSliderGallery" v-if="data.image.length != 0 ">
											<div class="carousel-cell w-100" v-for="image in data.image">
												<div class="img-hover-zoom radius-6 blur-image-bg" style="height:270px;">
													<img :src="image.image_url" class="img" :alt="getMerchant.name">
                          <div class="bg" :style="{ backgroundImage: `url('${image.image_url}')` }"></div>
												</div>
											</div>
										</flickity>
										<img :src="image_undefine" v-else class="img-fit slider-hover" :alt="getMerchant.name" style="height:275px;">
									</div>
									<div class="w-100 pt-3">
										<router-link :to="'/'+getMerchant.code+'/room-type/'+data.id+''">
											<p class="mb-1 body-1-2 font-bold text-18">{{data.name}}</p>
										</router-link>
										<p class="mb-0 body-2-2 text-14">{{$t('hotel.starting-from')}}:</p>
										<p class="mb-2 body-2-2-3 text-16 text-orange">{{formatCurrency(data.best_price.final_price)}}</p>
										<div class="pb-2 div-truncate">
											<div class="d-inline-block mr-2 mb-1" id="room-size">
												<i class="simple-icon-size-fullscreen text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
												<p class="mb-0 body-2-1 d-inline-block align-middle">{{data.room_size}} m²</p>
											</div>
											<b-tooltip target="room-size" placement="bottom" :title="$t('hotel.unit-type.'+data.type+'.size')">
											</b-tooltip>
											<div class="d-inline-block mr-2 mb-1" id="total-room">
												<i class="simple-icon-home text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
												<p class="mb-0 body-2-1 d-inline-block align-middle">{{data.total_rooms}} {{$t('hotel.room-type.rooms')}}</p>
											</div>
											<b-tooltip target="total-room" placement="bottom" :title="$t('hotel.room-type.total-unit')">
											</b-tooltip>
											<div class="d-inline-block mr-2" id="bed">
												<i class="simple-icon-grid text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
												<p class="mb-0 body-2-1 d-inline-block align-middle text-truncate">
													<template v-for="(bed, index) in data.bed">
														{{bed.qty}} {{bed.name}}<span v-if="index + 1 < data.bed.length">,</span>
													</template>
												</p>
											</div>
											<b-tooltip target="bed" placement="bottom" :title="$t('hotel.room-type.bed-type')">
										</b-tooltip>
										</div>
										<!-- <p class="mb-0 body-2-2-1 mb-0 text-15 text-truncate">{{data.desc}}</p> -->
										<div class="row slim-grid-row mt-3">
											<div class="col-12 col-md-12 col-xl-6 mb-md-2 mb-xl-0">
												<router-link :to="'/'+getMerchant.code+'/room-type/'+data.id+''">
													<button type="button" class="ga-btn-primary-md ga-btn-primary-outline">{{$t('hotel.concierge.fitur.read-more')}}</button>
												</router-link>
											</div>
											<div class="col-12 col-md-12 col-xl-6">
												<router-link :to="'/'+getMerchant.code+'/hotel-direct-detail/room_type/room_type/'+data.id+''">
													<button type="button" class="ga-btn-primary-md ga-btn-primary">{{$t('hotel.action.book-now')}}</button>
												</router-link>
											</div>
										</div>
									</div>
								</div>
							</div>
						</flickity>
					</div>
				</template>
			</div>
		</b-skeleton-wrapper>
	</div>
</template>
<script>
  import Flickity from 'vue-flickity';
  import {mapGetters} from 'vuex'
	import moment from 'moment';
	import {get} from '@/services/index.js'
  import {formatCurrency,formatDate} from '@/utils/index.js'

	export default{
		props:{
			data_source:{
				type: String,
				default: 'self'
			},
			parent_data: {
				type: Array,
				default: () => []
			},
			is_load: {
				type: Boolean,
				default: true
			}
		},
		components:{
			Flickity
		},
		data(){
			return{
				loading: true,
				freeScrollSlider: {
          initialIndex: 0,
          autoPlay: 6000,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: true,
          draggable: true,
          wrapAround: true,
          contain: true,
          cellAlign: 'left',
          groupCells: 2
        },
        freeScrollSliderGallery: {
          initialIndex: 0,
          autoPlay: 4000,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: true,
          draggable: false,
          wrapAround: false,
          contain: false,
          cellAlign: 'left',
          groupCells: false
        },
        room_type: [],
        date:{
					check_in: moment().toDate(),
					check_out: moment(moment().toDate()).add(this.$defaultFilterBE('night'),'d').toDate()
				},
				image_undefine: 'https://guestapps.s3-ap-southeast-1.amazonaws.com/noimage.png',
				test: true
			}
		},
		mounted(){
			if(this.data_source == 'self'){
				this.loadRoomType()
			}
		},
		computed:{
			...mapGetters(['getMerchant']),
			display(){
				let return_data = {
					data: this.room_type,
					loading: this.loading
				}
				if(this.data_source == 'parent'){
					return_data = {
						data: this.parent_data,
						loading: this.is_load
					}
				}
				return return_data
			}
		},
		methods:{
			loadRoomType(){
				return new Promise((success,fail)=>{
					this.loading = true
					get("CORE_HOTEL",`room-type-list?adult=${this.$defaultFilterBE('adult')}&child=0&infant=0&merchant_id=${this.getMerchant.id}&check_in_date=${this.formatTime(this.date.check_in)}&check_out_date=${this.formatTime(this.date.check_out)}&use_promotion_combine=true`).then(response=>{
						if (response.data.success) {
							this.room_type = response.data.data
							success()
						}else{
							fail(response.data.message)
						}
						this.loading = false
					})
				})
			},
			formatTime(date){
				let format = "YYYY-MM-DD"
        return moment(date).format(format)
      },
      formatCurrency(data) {
        return formatCurrency(data)
      },
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/general/RoomTypePreview.vue